<template>
    <div class="row">
        <div class="col-lg-12 setforsearchbarpanel position-relative innersltpad">
            <div class="searchbar_tops">
                <div class="iq-search-bar device-search">
                    <form>
                        <div class="input-prepend input-append">
                            <label class="searchbox">
                                <input
                                class="search-query text search-input"
                                type="text"
                                placeholder="Search in MDrive (Coming Soon) "
                                />
                                <a class="search-link" href="javascript:void(0);">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                    d="M16.296 2.043c.407 1.817 1.284 2.716 3.317 3.089.14 0 .255.104.255.233s-.114.233-.255.233c-1.982.373-2.909 1.218-3.315 3.081a.246.246 0 0 1-.243.18.245.245 0 0 1-.245-.191c-.407-1.818-1.28-2.697-3.313-3.07-.14 0-.254-.104-.254-.233s.114-.233.254-.233c1.982-.373 2.91-1.223 3.317-3.087a.247.247 0 0 1 .241-.175c.117 0 .212.074.241.173Z"
                                    fill="url(#_3085173834__a)"
                                    ></path>
                                    <path
                                    d="M15.094 17.436A7.5 7.5 0 1 1 10 4.046v1.503A6 6 0 1 0 16.446 11h1.504a7.466 7.466 0 0 1-1.46 5.003l4.25 4.25a1 1 0 0 1-1.414 1.414l-4.232-4.231Z"
                                    fill="url(#_3085173834__b)"
                                    ></path>
                                    <path
                                    d="M13.666 8.964c-.857-.236-1.356-.615-1.527-1.4 0-.095-.084-.172-.187-.172s-.187.077-.187.171c-.257.786-.67 1.244-1.528 1.401-.103 0-.187.077-.187.171 0 .095.084.172.187.172.857.235 1.357.614 1.528 1.4 0 .095.084.171.187.171s.187-.076.187-.171c.257-.786.67-1.243 1.527-1.4.104 0 .187-.077.187-.172 0-.094-.083-.171-.187-.171Z"
                                    fill="url(#_3085173834__c)"
                                    ></path>
                                    <defs>
                                    <linearGradient
                                        id="_3085173834__a"
                                        x1="-6.063"
                                        y1="11.915"
                                        x2="13.914"
                                        y2="29.878"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stop-color="#03A5AB"></stop>
                                        <stop offset="1" stop-color="#8B3DFF"></stop>
                                    </linearGradient>
                                    <linearGradient
                                        id="_3085173834__b"
                                        x1="-6.063"
                                        y1="11.915"
                                        x2="13.914"
                                        y2="29.878"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stop-color="#03A5AB"></stop>
                                        <stop offset="1" stop-color="#8B3DFF"></stop>
                                    </linearGradient>
                                    <linearGradient
                                        id="_3085173834__c"
                                        x1="-6.063"
                                        y1="11.915"
                                        x2="13.914"
                                        y2="29.878"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stop-color="#03A5AB"></stop>
                                        <stop offset="1" stop-color="#8B3DFF"></stop>
                                    </linearGradient>
                                    </defs>
                                </svg>
                                </a>
                            </label>
                        </div>
                    </form>
                </div>
            </div>
            <i class="noformobile">Hi {{$store.state.user.userInfo.name}}!</i>
            <div class="userboxpart" >
                <div class="icon"
                ><img
                    class="rounded img-fluid avatar-40"
                    :src="img_url + '' + $store.state.user.userInfo.user_image"
                    :alt="$store.state.user.userInfo.name"
                /></div>
                <h4>
                <i>{{ $store.state.user.userInfo.name }}</i>
                <p>{{ $store.state.user.userInfo.role_name }}</p>
                </h4>
            </div>
        </div>
        <div class="htheightDash">
            <div class="col-lg-12">
                <div class="card card-block homedashclassdO card-stretch card-transparent m-0">                
                    <div class="card-header d-flex justify-content-between pb-0">
                        <div class="header-title pageMaintitlesetback w-100">
                            <h4 class="card-title float-left">Starred</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card m-0 py-3 px-0">
                    <ListingFolder :isMain="mainParam"  />
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card m-0 p-0">
                    <ListingFiles :isMain="mainParam" />
                </div>
            </div>
            <div class="col-lg-12" v-if="$store.state.starred.tableFolderLoader === 2 && $store.state.starred.tableFileLoader === 2">
                <ComponentStarredNoData />        
            </div>
        </div>
    </div>
</template>
<script>
import ListingFiles from '@/components/Folder/ListingFiles.vue';
import ListingFolder from '@/components/Folder/ListingFolder.vue';
import ComponentStarredNoData from '@/components/Widgets/Icon/ComponentStarredNoData.vue';
import $ from "jquery";
    export default {
        name: 'StarredPage',
        components: {
            ListingFiles,
            ComponentStarredNoData,
            ListingFolder
        },
        async mounted() {
            this.$store.state.pageTitle = ''
            this.$store.state.isLogin = 1
            this.$store.state.currentPageSlug = 'starred';
            $('body').removeClass('sidebar-main');
            if (this.$store.state.isActiveToken != '1') {
                // console.log(this.currentDate);
            } else {
                // await this.loadDashboardCnt();
            }
        },
        data() {
            return {
                mainParam: 'starred',
                img_url: process.env.VUE_APP_IMG_URL,
            };
        },
        methods: {
            // 
        },
    }
</script>